const PICKUP_LINK_KEY = "pickup-location-link";

export function rememberPickupLink(hash, storage = window.sessionStorage) {
  storage.setItem(PICKUP_LINK_KEY, hash);
}

export function getRememberedPickupLink(storage = window.sessionStorage) {
  return storage.getItem(PICKUP_LINK_KEY);
}

export function forgetPickupLink(storage = window.sessionStorage) {
  storage.removeItem(PICKUP_LINK_KEY);
}
